"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PieSettings;
exports.initialValues = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _style = _interopRequireDefault(require("../common/style.css"));
var _SliderInput = _interopRequireDefault(require("../common/SliderInput"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _FieldGroup = _interopRequireDefault(require("../common/FieldGroup"));
var _ThemeFields = _interopRequireDefault(require("../common/ThemeFields"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialValues = {
  innerRadius: 0.5,
  padAngle: 0,
  cornerRadius: 0,
  startAngle: 0,
  endAngle: 360,
  enableArcLabels: true,
  piePreset: 'donut',
  customColors: '#b3e2cd',
  margin: {
    left: 80,
    right: 150,
    top: 50,
    bottom: 80
  }
};
exports.initialValues = initialValues;
var presetMap = {
  arc: {
    innerRadius: 0.5,
    padAngle: 0,
    cornerRadius: 0,
    startAngle: 90,
    endAngle: -90
  },
  pie: {
    innerRadius: 0,
    padAngle: 0,
    cornerRadius: 0,
    startAngle: 0,
    endAngle: 360
  },
  donut: {
    innerRadius: 0.5,
    padAngle: 0,
    cornerRadius: 0,
    startAngle: 0,
    endAngle: 360
  }
};
var piePresets = [{
  value: 'donut',
  label: 'Donut'
}, {
  value: 'pie',
  label: 'Pie'
}, {
  value: 'arc',
  label: 'Arc'
}];
function PieSettings(_ref) {
  var field = _ref.field,
    form = _ref.form,
    children = _ref.children;
  (0, _react.useEffect)(function () {
    form.setFieldValue("".concat(field.name), _objectSpread(_objectSpread({}, initialValues), field.value));
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement(PieSettings.Chart, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(PieSettings.Theme, {
    field: field,
    form: form
  }), children);
}
PieSettings.Chart = function (_ref2) {
  var field = _ref2.field,
    form = _ref2.form,
    children = _ref2.children;
  var resetOptions = function resetOptions() {
    field.value.piePreset && form.setFieldValue("".concat(field.name), _objectSpread(_objectSpread({}, field.value), presetMap[field.value.piePreset]));
  };
  (0, _react.useEffect)(function () {
    resetOptions();
  }, [field.value.piePreset]);
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Chart"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Style",
    name: "".concat(field.name, ".piePreset"),
    component: _cccisdFormik.CccisdSelect,
    options: piePresets
  }), /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Advanced Options",
    isOpen: false
  }, /*#__PURE__*/_react["default"].createElement(_SliderInput["default"], {
    name: "".concat(field.name, ".innerRadius"),
    label: "Inner Radius",
    min: 0,
    max: 1,
    step: 0.05
  }), /*#__PURE__*/_react["default"].createElement(_SliderInput["default"], {
    name: "".concat(field.name, ".padAngle"),
    label: "Space Between Slices",
    min: 0,
    max: 45
  }), /*#__PURE__*/_react["default"].createElement(_SliderInput["default"], {
    name: "".concat(field.name, ".cornerRadius"),
    label: "Round Slice Corners",
    min: 0,
    max: 45
  }), /*#__PURE__*/_react["default"].createElement(_SliderInput["default"], {
    name: "".concat(field.name, ".startAngle"),
    label: "Start Angle",
    min: -360,
    max: 360
  }), /*#__PURE__*/_react["default"].createElement(_SliderInput["default"], {
    name: "".concat(field.name, ".endAngle"),
    label: "End Angle",
    min: -360,
    max: 360
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default ".concat(_style["default"].resetBtn),
    onClick: function onClick() {
      resetOptions();
    }
  }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], null), " Reset")), children);
};
PieSettings.Theme = function (_ref3) {
  var field = _ref3.field,
    form = _ref3.form,
    children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Theme"
  }, /*#__PURE__*/_react["default"].createElement(_ThemeFields["default"], {
    field: field,
    form: form
  }), children);
};